var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-row",
        { staticStyle: { "margin-bottom": "15px" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("global.search"),
                  "append-icon": "search",
                  "hide-details": "",
                  "single-line": ""
                },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          ),
          _c("v-spacer"),
          _vm.hasPermissionForEdit ? _c("vehicle-dialog") : _vm._e()
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.vehicles,
          search: _vm.search
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.plates))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.model))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.engine_capacity))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.typeName))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    props.item.is_private
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("global.yes")))])
                      : _vm._e(),
                    !props.item.is_private
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("global.no")))])
                      : _vm._e()
                  ]),
                  _c(
                    "td",
                    { staticClass: "text-center" },
                    [
                      _vm.hasPermissionForEdit
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              staticClass: "mx-0",
                                              attrs: {
                                                disabled:
                                                  _vm.$store.getters[
                                                    "Ajax/loading"
                                                  ],
                                                icon: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.editItem(
                                                    props.item
                                                  )
                                                }
                                              }
                                            },
                                            on
                                          ),
                                          [_c("v-icon", [_vm._v("edit")])],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("global.edit")) + " ")]
                          )
                        : _vm._e(),
                      _vm.hasPermissionForEdit
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              staticClass: "mx-0",
                                              attrs: {
                                                disabled:
                                                  _vm.$store.getters[
                                                    "Ajax/loading"
                                                  ],
                                                icon: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.deleteItem(
                                                    props.item
                                                  )
                                                }
                                              }
                                            },
                                            on
                                          ),
                                          [_c("v-icon", [_vm._v("delete")])],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("global.delete")) + " "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }